// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iUO9","content":"styles_content__2KgEp","row":"styles_row__1xDuA","footer":"styles_footer__2ZvVa","phraseLength":"styles_phraseLength__UIsXm"};